import { Entity, parseEntityRef } from '@backstage/catalog-model';

export const DEFAULT_WORKFLOW_OWNER = 'devops';

// A team's main group and its namespaced subgroups share one navigation item.
export function workflowOwnerKey(owner: string, namespace = 'default'): string {
  const ref = parseEntityRef(owner.toLowerCase(), {
    defaultKind: 'group',
    defaultNamespace: namespace.toLowerCase(),
  });
  if (ref.kind.toLowerCase() !== 'group') {
    return `${ref.kind}:${ref.namespace}/${ref.name}`;
  }
  return ref.namespace === 'default' ? ref.name : ref.namespace;
}

export function getWorkflowOwner(entity: Entity): string | undefined {
  const owner = entity.relations?.find(r => r.type === 'ownedBy')?.targetRef;
  const ref = owner ?? entity.spec?.owner;
  if (typeof ref !== 'string' || !ref.trim()) {
    return undefined;
  }
  return workflowOwnerKey(ref, entity.metadata.namespace);
}

export function workflowOwnerTitle(owner: string): string {
  return owner === DEFAULT_WORKFLOW_OWNER ? 'devops' : owner;
}

export function workflowOwnerUrl(owner: string): string {
  return `/workflows/templates?owner=${encodeURIComponent(owner)}`;
}

export function getWorkflowOwners(entities: Entity[]): string[] {
  return [
    DEFAULT_WORKFLOW_OWNER,
    ...Array.from(new Set(entities.map(getWorkflowOwner)))
      .filter(
        (owner): owner is string => !!owner && owner !== DEFAULT_WORKFLOW_OWNER,
      )
      .sort((a, b) => a.localeCompare(b)),
  ];
}
